<script setup>
  import { Head, Link, useForm } from '@inertiajs/vue3';
  import InputError from '@/Components/InputError.vue';
  import InputLabel from '@/Components/InputLabel.vue';
  import MainButton from '@/Components/MainButton.vue';
  import TextInput from '@/Components/TextInput.vue';
  import NewFooter from '@/Components/NewFooter.vue';

  import Rectangle4 from '../../../../public/images/PurpleSmoke2.jpg';
  import Registration from '../../../../public/images/GirlsWhispering.png';

  defineProps({
    status: String
  });

  const form = useForm({
    email: ''
  });

  const submit = () => {
    form.post(route('password.email'));
  };
</script>

<template>
  <Head title="Forgot Password" />

  <div class="flex h-[870px] w-full flex-col md:h-[80vh] md:flex-row">
    <!-- Left Side with Images -->
    <div class="relative flex overflow-hidden h-1/4 md:h-full md:w-2/5">
      <img
        :src="Rectangle4"
        alt=""
        class="absolute inset-0 object-cover w-full h-full"
      />
      <div
        class="absolute py-16 -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2 h-80 w-60 rounded-2xl md:py-0"
      >
        <img
          :src="Registration"
          alt="Login Image"
          class="h-full w-full !rounded-xl border border-purple-400 object-cover opacity-50"
        />
      </div>
    </div>

    <!-- Right Side Form -->
    <div class="p-4 bg-white h-1/2 md:h-full md:w-3/5">
      <h1 class="mt-6 mb-6 text-4xl font-semibold font-title md:mt-20">
        Forgot Password
      </h1>

      <div class="mb-4 text-lg text-black">
        No worries!
        <br />
        Just enter your email and we'll send a reset link.
      </div>

      <div v-if="status" class="mb-4 text-sm font-medium text-green-600">
        {{ status }}
      </div>

      <form @submit.prevent="submit">
        <div>
          <InputLabel for="email" value="Email" />
          <v-text-field
            v-model="form.email"
            variant="outlined"
            type="email"
            required
            autofocus
            autocomplete="username"
          ></v-text-field>
          <InputError :message="form.errors.email" />
        </div>

        <div class="flex flex-col w-full mt-4">
          <MainButton
            class="w-full justify-center !rounded-full"
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
          >
            Email Password Reset Link
          </MainButton>
          <div class="flex justify-center mt-2">
            <Link
              :href="route('login')"
              class="text-sm transition duration-200 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              Back to Login
            </Link>
          </div>
        </div>
      </form>
    </div>
  </div>

  <NewFooter class="-mt-52 md:mt-0" />
</template>
